import { render } from "./RejectModal.vue?vue&type=template&id=3b16af32&scoped=true"
import script from "./RejectModal.vue?vue&type=script&lang=js"
export * from "./RejectModal.vue?vue&type=script&lang=js"

import "./RejectModal.vue?vue&type=style&index=0&id=3b16af32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b16af32"]])

export default __exports__